exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#292d32;color:#e6e6e6;padding:1rem}.footer .actions{margin-left:auto}.footer .actions .contact-link{font-color:white;margin-right:2rem}", ""]);

// exports
